var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.226074 18.3019C0.226074 8.57453 8.11164 0.688965 17.839 0.688965C27.5663 0.688965 35.4519 8.57453 35.4519 18.3019C35.4519 28.0292 27.5663 35.9148 17.839 35.9148C8.11164 35.9148 0.226074 28.0292 0.226074 18.3019Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_1895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 7C11.1478 7 5.99927 12.1486 5.99927 18.5C5.99927 24.8514 11.1478 30 17.4993 30C23.8507 30 28.9993 24.8514 28.9993 18.5C28.9993 12.1486 23.8507 7 17.4993 7Z",
    fill: "#0288D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7493 15.6248H14.0493V24.2498H11.7493V15.6248ZM12.8924 14.4748H12.8797C12.1932 14.4748 11.7493 13.9631 11.7493 13.3242C11.7493 12.6854 12.207 12.1748 12.9056 12.1748C13.6042 12.1748 14.036 12.6716 14.0493 13.3242C14.0493 13.9631 13.6054 14.4748 12.8924 14.4748ZM23.8243 18.7873C23.8243 17.0405 22.4086 15.6248 20.6618 15.6248C19.5911 15.6248 18.6464 16.1584 18.0743 16.9726V15.6248H15.7743V24.2498H18.0743V19.6498C18.0743 18.697 18.8465 17.9248 19.7993 17.9248C20.752 17.9248 21.5243 18.697 21.5243 19.6498V24.2498H23.8243V18.7873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_1895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(5.99927 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/in-icon.ac522c5a4d37f6d233f9321b39a0450a.svg";
export { ForwardRef as ReactComponent };